var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { mq, rem } from '@heathmont/moon-utils';
import styled from 'styled-components';
import { SelectElement } from '../../select/private/element';
import { Input } from '../input/input';
import { inputColors } from '../input/settings';
/**
 * Styles
 */
const LabelContent = styled.span(({ disabled, flex, dir, theme }) => [
    {
        display: 'block',
        marginBottom: rem(theme.space.small),
        color: inputColors('label')(theme),
        fontSize: rem(theme.base.fontSize),
    },
    flex && {
        [mq(theme.breakpoint.small)]: {
            flex: 1,
            paddingRight: rem(theme.space.default),
            marginBottom: 0,
        },
    },
    disabled && {
        opacity: 0.5,
    },
    dir === 'rtl' && {
        textAlign: 'right',
    },
]);
const LabelFlex = styled.label(({ flex, inputGrow, theme: { breakpoint } }) => flex && {
    [mq(breakpoint.small)]: Object.assign({ display: 'flex', alignItems: 'center' }, (inputGrow && {
        [`${Input}, ${SelectElement}`]: {
            flex: inputGrow,
        },
    })),
});
/**
 * Component
 */
const Label = (_a) => {
    var { text, disabled, flex, children, inline, inputGrow = 1, dir } = _a, props = __rest(_a, ["text", "disabled", "flex", "children", "inline", "inputGrow", "dir"]);
    return inline ? (React.createElement("label", Object.assign({ dir: dir }, props), text)) : (React.createElement(LabelFlex, Object.assign({ flex: flex, inputGrow: inputGrow }, props),
        React.createElement(LabelContent, { dir: dir, disabled: disabled, flex: flex }, text),
        React.Children.only(children)));
};
export { Label };
